import { ACTION_GET_PAYMENT_RATE, ACTION_GET_PAYMENT_RATE_ERROR, ACTION_GET_PAYMENT_RATE_SUCCESS } from "../actions"

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getPaymentRateReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GET_PAYMENT_RATE:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_GET_PAYMENT_RATE_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_GET_PAYMENT_RATE_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}